module.exports = __webpack_public_path__ + "static/media/gitlab.a8415916.svg";